import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const StatTile = ({ label, value }) => (
    <Box
        sx={{
            flex: '1 1 180px',
            minWidth: 160,
            borderTop: (theme) => `3px solid ${theme.palette.primary.main}`,
            borderRadius: '14px',
            padding: '14px 18px',
            backgroundColor: (theme) => theme.palette.background.paper,
            boxShadow: (theme) =>
                theme.palette.mode === 'dark'
                    ? '0 2px 8px rgba(0,0,0,0.35)'
                    : '0 2px 8px rgba(31,45,61,0.08)',
        }}
    >
        <Typography
            variant="caption"
            sx={{
                display: 'block',
                fontWeight: 700,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: (theme) => theme.palette.text.secondary,
                marginBottom: '4px',
            }}
        >
            {label}
        </Typography>
        <Typography
            sx={{
                fontWeight: 700,
                fontSize: '1.35rem',
                color: (theme) => theme.palette.text.primary,
            }}
        >
            {value}
        </Typography>
    </Box>
);

StatTile.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.node.isRequired,
};

export default StatTile;
